import * as THREE from 'three';
import suppressExpoWarnings from './suppressWarnings';
THREE['suppressExpoWarnings'] = suppressExpoWarnings;
export default THREE;
